import { render, staticRenderFns } from "./CadastroAmostraRastroStatus.vue?vue&type=template&id=09592148&"
import script from "./CadastroAmostraRastroStatus.vue?vue&type=script&lang=js&"
export * from "./CadastroAmostraRastroStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports